<form [formGroup]="form" class="row">
  <!-- Caso rolGuardia  -->

  <div class="col-12">
    <p>Datos del personal interno involucrado</p>
  </div>
  <div class="col-4">
    <mat-form-field class="wid" appearance="outline">
      <mat-label>Nombres y apellidos personal</mat-label>
      <input formControlName="nombre" matInput />
    </mat-form-field>
  </div>
  <div class="col-4">
    <mat-form-field class="wid" appearance="outline">
      <mat-label>Cargo</mat-label>
      <input formControlName="cargo" matInput />
    </mat-form-field>
  </div>
  <div class="col-4">
    <mat-form-field class="wid" appearance="outline">
      <mat-label>NM</mat-label>
      <input formControlName="NM" matInput />
    </mat-form-field>
  </div>
  <div class="col-4">
    <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>C.I./RIF afectado *</mat-label>
      <input
        type="text"
        formControlName="ci"
        matInput
        ciRif
        placeholder="J123456789"
      />
      <mat-error *ngIf="form.get('ci').hasError('pattern')"
        >El C.I./RIF es <strong>invalido</strong></mat-error
      >
    </mat-form-field>
  </div>
  <div class="col-12">
    <mat-form-field class="wid" appearance="outline">
      <mat-label>Descripción</mat-label>
      <textarea
        matInput
        placeholder="Descripción del caso: datos del personal interno involucrado..."
        formControlName="descripcion"
      ></textarea>
    </mat-form-field>
  </div>
</form>
